import React from 'react';
import PropTypes from 'prop-types';
import { Link as GatsbyLink } from 'gatsby';
import { AnchorLink } from 'gatsby-plugin-anchor-links';

const Link = ({
  children, to, activeClassName, partiallyActive, ...other
}) => {
  // any internal link will start with exactly one slash, and that anything else is external.
  const internal = /^\/(?!\/)/.test(to);
  // any file will have a dot in the url
  const file = /\.[0-9a-z]+$/i.test(to);

  if (internal && !file) {
    return (
      <GatsbyLink
        to={to}
        activeClassName={activeClassName}
        partiallyActive={partiallyActive}
        {...other}
      >
        {children}
      </GatsbyLink>
    );
  }

  // if a link simply jumps to a section
  if (/^#(?!#)/.test(to)) {
    return (
      <AnchorLink to={to} {...other}>
        {children}
      </AnchorLink>
    );
  }

  return (
    <a href={to} target="_blank" rel="noopener noreferrer" {...other}>
      {children}
    </a>
  );
};

Link.propTypes = {
  to: PropTypes.string.isRequired,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  activeClassName: PropTypes.string,
  partiallyActive: PropTypes.bool,
};

Link.defaultProps = {
  activeClassName: null,
  partiallyActive: true,
};

export default Link;
